import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  getLanguageKeys,
  getContextMenu,
  getElements,
  getElementIndex
} from '@/store/getters'
import {
  toggleContextMenu,
  deleteElemet,
  duplicateElement,
  sendElementToBack,
  sendElementToFront,
  sendElementToBackOne,
  sendElementToFrontOne,
  toggleSidebar
} from '@/store/actions'
import IconComponent from './IconComponent'

class ContextMenu extends Component {
  componentWillMount() {
    document.addEventListener('mousedown', this.toggleOutisde)
  }

  toggleOutisde = e => {
    if (!this.refs.contextMenu) {
      return
    }
    if (this.refs.contextMenu.contains(e.target)) {
      return
    }
    const { toggleContextMenu } = this.props
    toggleContextMenu({
      show: false
    })
  }

  handleSendElementToBack = (data) => {
    const { toggleSidebar, sendElementToBack } = this.props

    toggleSidebar({
      isOpened: true,
      name: 'layers'
    })
    sendElementToBack(data)
  }

  handleSendElementToFront = (data) => {

    const { toggleSidebar, sendElementToFront } = this.props

    toggleSidebar({
      isOpened: true,
      name: 'layers'
    })
    sendElementToFront(data)
  }

  render() {
    const {
      locales,
      contextMenu,
      deleteElemet,
      duplicateElement,
      elementIndex,
      elements,
    } = this.props
    const { data } = contextMenu

    return contextMenu.show && data ? (
      <div
        ref="contextMenu"
        className="context-menu"
      // style={{ top: contextMenu.top, left: contextMenu.left }}
      >
        <button
          ba-tooltip-title={data.content.elementType}
          ba-tooltip-position='top'
          ba-tooltip-color='dark'
          className="basic-button flat-icon icon-button"
          onClick={() => this.props.editElement(data)}
        >
          <IconComponent icon="pencil-edit" />
        </button>
        <button
          ba-tooltip-title={locales['contextmenu-send-back']}
          ba-tooltip-position='top'
          ba-tooltip-color='dark'
          className="basic-button flat-icon icon-button"
          disabled={elementIndex === 0}
          onClick={() => this.handleSendElementToBack(data)}
        >
          <IconComponent icon="from-front" />
        </button>
        <button
          ba-tooltip-title={locales['contextmenu-send-front']}
          ba-tooltip-position='top'
          ba-tooltip-color='dark'
          className="basic-button flat-icon icon-button"
          disabled={elementIndex === elements.length - 1}
          onClick={() => this.handleSendElementToFront(data)}
        >
          <IconComponent icon="from-back" />
        </button>

        <button
          ba-tooltip-title={locales['general-duplicate']}
          ba-tooltip-position='top'
          ba-tooltip-color='dark'
          className="basic-button flat-icon icon-button"
          onClick={() => duplicateElement(data)}
        >
          <IconComponent icon="copy" />
        </button>
        <button
          ba-tooltip-title={locales['general-delete']}
          ba-tooltip-position='top'
          ba-tooltip-color='dark'
          className="basic-button flat-icon icon-button"
          onClick={() => deleteElemet(data)}
        >
          <IconComponent icon="delete" />
        </button>
      </div>
    ) : null
  }
}

const mapStateTiProps = state => {
  const locales = getLanguageKeys(state)
  const contextMenu = getContextMenu(state)
  const elements = getElements(state)
  const { data } = contextMenu
  const elementIndex = getElementIndex(state, data ? data.id : -1)
  return {
    locales,
    contextMenu,
    elements,
    elementIndex
  }
}

export default connect(
  mapStateTiProps,
  {
    toggleContextMenu,
    deleteElemet,
    duplicateElement,
    sendElementToBack,
    sendElementToFront,
    sendElementToBackOne,
    sendElementToFrontOne,
    toggleSidebar
  }
)(ContextMenu)



// WEBPACK FOOTER //
// ./src/components/commons/ContextMenu.js